module.exports = __webpack_public_path__ + "static/media/stairs.553ac2ba.svg";